/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { AGGError } from '@jira/platform__graphql-relay-errors/src/index.tsx';

type GraphQLError =
	| AGGError
	| {
			readonly extensions:
				| {
						readonly errorType: string | null | undefined;
						readonly statusCode: number | null | undefined;
				  }
				| null
				| undefined;
			readonly message: string | null | undefined;
	  }
	| null
	| undefined;

export class TrackedGraphQLError extends Error {
	traceId: string | undefined;

	statusCode: number | undefined;

	message: string;

	constructor(
		public errorMessage: string,
		public errors: GraphQLError[],
		public traceIds?: string[],
	) {
		super(errorMessage);
		this.errors = errors;

		// Get first trace id
		this.traceId = traceIds?.[0];

		// Get first status code
		this.statusCode = errors
			?.map((graphQLError) =>
				graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null,
			)
			.filter(Boolean)?.[0];

		// Combine error messages
		this.message =
			errors
				?.map((graphQLError) => graphQLError?.message)
				.filter(Boolean)
				.join('; ') ?? errorMessage;
	}
}
